import {Box} from "@mui/material";
import {DetailsHeader} from "../../../../common/details/DetailsHeader";
import {DetailsTableProps} from "../../../../common/details/DetailsTable";

interface PaymentDetailsTableProps extends DetailsTableProps {
    qrCode?: React.ReactNode;
}

export function PaymentDetailsTable(props: Readonly<PaymentDetailsTableProps>) {
    return (
            <Box minWidth={"sm"}>
                <Box mb={2}>
                    {props.header &&
                            <DetailsHeader>{props.header}</DetailsHeader>
                    }
                    <Box display="flex" flexDirection={{xs: "column", md: "row"}}>
                        <Box
                                flex="70%"
                                sx={props.qrCode ? {"--details-col-label-width": {xs: "30%", md: "calc(30%/0.70)"}} : {}}
                        >
                            {props.prologue &&
                                    <Box mb={2}>{props.prologue}</Box>
                            }
                            <table width={"100%"} className={"DetailsTable"}>
                                {props.children}
                            </table>
                            {props.epilogue &&
                                    <Box mt={2}>{props.epilogue}</Box>
                            }
                        </Box>
                        {props.qrCode &&
                                <Box flex="30%" textAlign={{xs: "center", md: "right"}} marginTop="10px">{props.qrCode}</Box>
                        }
                    </Box>
                </Box>
            </Box>
    );
}
